import * as React from 'react';
import { ApplicationState, AppState, CaseSettingsState } from '../../store';
import { ApplicationContext, AppContext } from '../../context/Contexts';
import { RouteComponentProps } from 'react-router';
import { connect } from 'react-redux';
import { ITranslatorService } from '../../services/Interfaces/ITranslatorService';
import { Box, Button, Card, Grid, TextField } from '@material-ui/core';
import moment from 'moment';
import { withSnackbar, ProviderContext } from 'notistack';
import { MuiPickersUtilsProvider, DatePicker } from '@material-ui/pickers';
import MomentUtils from '@date-io/moment';
import { MaterialUiPickersDate } from '@material-ui/pickers/typings/date';
import _ from 'lodash';
import { ValidatorForm } from 'react-material-ui-form-validator';
import FileSaver from 'file-saver';
import { LanguageCode } from '../../helpers/Constants';
import { ScaleLoader } from 'react-spinners';
import { IVehicleService } from '../../services/Interfaces/IVehicleService';
import { IOrganizationService } from '../../services/Interfaces/IOrganizationService';
import { Organization } from '../../interfaces/Organization';
import { MvoVehiclesExportRequestDto } from '../../interfaces/Vehicle';
import { Autocomplete } from '@material-ui/lab';

type MvoVehiclesExportProps = {
    appState: AppState;
    caseSettingsState: CaseSettingsState;
  } & ProviderContext &
    RouteComponentProps;

interface IMvoVehiclesExportState {
  isLoading: boolean;
  filterStartDate: Date | null;
  filterEndDate: Date | null;
  startDateError: string;
  endDateError: string;
  organizationEntities: Organization[];
  selectedOrgEntities: Organization[];
}

class LocalizedUtils extends MomentUtils {
}

class MvoVehiclesExport extends React.PureComponent<MvoVehiclesExportProps, IMvoVehiclesExportState> {
  private translatorService!: ITranslatorService;
  private vehicleService!: IVehicleService;
  private organizationService!: IOrganizationService;
  static contextType = ApplicationContext;

  state = {
    isLoading: false,
    filterStartDate: null,
    filterEndDate: null,
    startDateError: '',
    endDateError: '',
    organizationEntities: [],
    selectedOrgEntities: []
  }  as IMvoVehiclesExportState;

  public async componentDidMount() {
    await this.loadData();
  }

  loadData = async () => {
    try {
      this.setState({ isLoading: true });

      const orgs = await this.organizationService.GetMvoOrganizations();

      this.setState({
        organizationEntities: orgs,
        isLoading: false
      });
    } catch (err: any) {
      this.setState({ isLoading: false });
      this.props.enqueueSnackbar(this.translatorService.Tranlate('ERROR_MSG', 'Eroare'), {
        variant: 'error'
      });
    } 
  };

  formatDate = (date: Date) =>  moment(date).format('YYYY-MM-DD');

  exportInfo = async () => {
    if (this.state.startDateError || this.state.endDateError) {
      return;
    }

    const language  = this.props.appState.language == LanguageCode.RO ? LanguageCode.RO : LanguageCode.EN;
    try {
      this.setState({ isLoading: true });

      const formatedStartDate = this.state.filterStartDate ? moment(this.state.filterStartDate).format("DD.MM.YYYY") : null;
      const formatedEndDate = this.state.filterEndDate ? moment(this.state.filterEndDate).format("DD.MM.YYYY") : null;

      const requestPayload = {
        startDate: this.state.filterStartDate ? this.formatDate(this.state.filterStartDate) : null,
        endDate: this.state.filterEndDate ? new Date(this.state.filterEndDate.setHours(23, 59, 59, 999)) : null,
        language: language,
        organizationIds: this.state.selectedOrgEntities.map((org) => org.id)
      }  as MvoVehiclesExportRequestDto;

      const fileBlob = await this.vehicleService.GetMvoVehiclesXlsx(
        requestPayload
      );
      FileSaver.saveAs(fileBlob, language ==  LanguageCode.RO ? 'Raport MVO '  + formatedStartDate + '-' + formatedEndDate + '.xlsx' : 'MVO Report'  + formatedStartDate + '-' + formatedEndDate + '.xlsx');
      
      this.setState({ isLoading: false });

      this.props.enqueueSnackbar(this.translatorService.Tranlate('SUCCES_MSG', 'OK'), {
        variant: 'success'
      });
    } catch (err: any) {
      this.setState({ isLoading: false });
      this.props.enqueueSnackbar(this.translatorService.Tranlate('ERROR_MSG', 'Eroare'), {
        variant: 'error'
      });
    }
  };

  handleOrgEntitiesChange = (newValue: any[]) => {
    this.setState(
      {
        selectedOrgEntities: newValue
      }
    );
  };

  validateDates = (startDate: Date | null, endDate: Date | null): void => {
    /*
    Validate start date
    */
    let startDateError = '';
    if (!startDate) {
      startDateError = this.translatorService.Tranlate('VALIDATORS_REQUIRED', 'Campul este obligatoriu');
    } else {
      if (endDate && startDate > endDate) {
        startDateError = this.translatorService.Tranlate(
          'EXPORT_START_DATE_ERROR',
          'De la trebuie sa fie mai mica decat pana la'
        );
      }
    }

    /*
    Validate end date
    */
    let endDateError = '';
    if (!endDate) {
      endDateError = this.translatorService.Tranlate('VALIDATORS_REQUIRED', 'Campul este obligatoriu');
    }

    this.setState({
      startDateError: startDateError,
      endDateError: endDateError
    });

  };


  handlefilterStartDateChange = async (date: MaterialUiPickersDate | null) => {
    if (date === null || !date.isValid) {
      return;
    }
    this.setState(
      {
        filterStartDate: date === null || !date.isValid ? null : date!.toDate(),
        startDateError: ''
      }
      
    );
  };

  handlefilterEndDateChange = async (date: MaterialUiPickersDate | null) => {
    if (date === null || !date.isValid) {
      return;
    }
    this.setState(
      {
        filterEndDate: date === null || !date.isValid ? null : date!.toDate(),
        endDateError: ''
      }
    );
  };

  renderFilters = () => {
    return (
      <ValidatorForm
        onSubmit={() => {
          this.exportInfo();
        }}
      >
      <div className="m-3 text-center">
        <Grid container spacing={2}>
          <Grid item xs={12} sm={4} md={4}>
            <Box mb={2}>
              <MuiPickersUtilsProvider
                libInstance={moment}
                utils={LocalizedUtils}
                locale={this.props.appState.language}
              >
                <DatePicker
                  fullWidth
                  openTo="date"
                  views={['year', 'month', 'date']}
                  variant="inline"
                  format={this.props.appState.dateFormat.toUpperCase()}
                  margin="none"
                  id="date-picker-inline-from"
                  label={this.translatorService.Tranlate('ORDERS_DATE_LABEL_FROM', 'De la')}
                  value={this.state.filterStartDate}
                  onChange={this.handlefilterStartDateChange}
                  autoOk={true}
                  error={this.state.startDateError ? true : false}
                  helperText={this.state.startDateError}
                  required={true}
                />
              </MuiPickersUtilsProvider>
            </Box>
          </Grid>
          <Grid item xs={12} sm={4} md={4}>
            <Box mb={2}>
              <MuiPickersUtilsProvider
                libInstance={moment}
                utils={LocalizedUtils}
                locale={this.props.appState.language}
              >
                <DatePicker
                  fullWidth
                  openTo="date"
                  views={['year', 'month', 'date']}
                  variant="inline"
                  format={this.props.appState.dateFormat.toUpperCase()}
                  margin="none"
                  id="date-picker-inline-to"
                  label={this.translatorService.Tranlate('ORDERS_DATE_LABEL_TO', 'Pana la')}
                  value={this.state.filterEndDate}
                  onChange={this.handlefilterEndDateChange}
                  autoOk={true}
                  error={this.state.endDateError ? true : false}
                  helperText={this.state.endDateError}
                  required={true}
                />
              </MuiPickersUtilsProvider>
            </Box>
          </Grid>
          <Grid item xs={12} sm={4} md={4}>
            <Box mb={2}>
              <Autocomplete
                id="orgEntities"
                size="small"
                multiple
                options={this.state.organizationEntities.sort(function (a, b) {
                  return a.displayName.localeCompare(b.displayName);
                })}
                value={this.state.selectedOrgEntities}
                onChange={(e: any, newValue: any | null) => this.handleOrgEntitiesChange(newValue)}
                getOptionLabel={(option: Organization) => option.displayName || ''}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    name="orgEntities"
                    value={this.state.selectedOrgEntities}
                    label={this.translatorService.Tranlate('MVO_ORGANIZATION_LABEL', 'Dealer')}
                    fullWidth
                  />
                )}
              />
            </Box>
          </Grid>
        </Grid>
        <div className="m-3 text-center">
          <Button
            className="mt-3"
            variant="contained"
            color="secondary"
            type="submit"
            onClick={() => {
              this.validateDates(this.state.filterStartDate, this.state.filterEndDate);
            }}
          >
            {this.translatorService.Tranlate('EXPORT_DATA', 'Export')}
          </Button>
        </div>
      </div>
    </ValidatorForm>
    );
  };

  
  public render() {
    this.translatorService = (this.context as AppContext).translatorService;
    this.vehicleService = (this.context as AppContext).vehicleService;
    this.organizationService = (this.context as AppContext).organizationService;

    return (
      <React.Fragment>
        <Card>
          <div>
            {this.renderFilters()}
          </div>
          <div className="d-flex flex-row text-center flex-wrap justify-content-center">
            <ScaleLoader color={'var(--primary)'} loading={this.state.isLoading} />
          </div>
        </Card>
      </React.Fragment>
    );
  }
}

export default connect(
  (state: ApplicationState) => ({
    appState: state.app,
    caseSettingsState: state.caseSettings
  }),
  null
)(withSnackbar(MvoVehiclesExport as any));
